// --- START OF FILE App.js version 34  Jan 16 2026 1:20am SB120 ---
// --- START OF FILE App.js version 33  Jan 11 2026 11:27pm SB119 ---
// --- START OF FILE App.js version 32  12/18/2025  9:02 PM - SB118c
// --- START OF FILE App.js version 31a  12/16/2025  11:38 PM - SB118b
// --- START OF FILE App.js version 31  12/14/2025  2:07 PM - SB118

import React, { useState, useEffect, createContext, useContext } from 'react';
import { HashRouter, Routes, Route, Link, Navigate, useParams, useNavigate, Outlet, NavLink } from 'react-router-dom'; // NEW ver 26 SB103: NavLink for active styling 

// Import Firebase services for client-side authentication
import { auth } from './firebaseConfig';
import { signInWithEmailAndPassword, signOut, onAuthStateChanged,
         createUserWithEmailAndPassword, sendPasswordResetEmail, sendEmailVerification } from 'firebase/auth';

import * as inventoryService from './api/inventoryService';
// import * as supplierService from './api/supplierService'; // most likely never used
import * as userService from './api/userService'; // began being used in fetchCurrentUserProfile.js - Ver 15
// import * as employeeService from './api/employeeService'; // Ver 21 // EmployeeForm imports this
// import * as rawItemCategoryService from './api/rawItemCategoryService'; // most likely never used
// import * as rawItemsService from './api/rawItemsService'; // most likely never used
// import * as itemVariantsService from './api/itemVariantsService'; // most likely never used
// import * as sitesService from './api/sitesService'; // most likely never used
// import * as itemVariantPackageService from './api/itemVariantPackageService'; // ver 33 most likely never used
import * as itmVrntPkgSuplrsPriceService from './api/itmVrntPkgSuplrsPriceService'; // ver 34 most likely never used

// Import .css file
import './App.css'

// Import components
import UserProfileForm from './UserProfileForm';
import TenantProfileForm from './TenantProfileForm';
import EmployeeList from './EmployeeList'; // Ver 21
import EmployeeForm from './EmployeeForm'; // Ver 21
import EmailVerificationScreen from './EmailVerificationScreen'; // Ver 25
import RawItemCategoryList from './RawItemCategoryList'; // Ver 27
import RawItemCategoryForm from './RawItemCategoryForm'; // Ver 27
import RawItemsList from './RawItemsList'; // Ver 28
import RawItemsForm from './RawItemsForm'; // Ver 28
import ItemVariantsList from './ItemVariantsList'; // Ver 29
import ItemVariantsForm from './ItemVariantsForm'; // Ver 29
import SupplierList from './SupplierList'; // Ver 30
import SupplierForm from './SupplierForm'; // Ver 30
import SitesList from './SitesList'; // Ver 31
import SitesForm from './SitesForm'; // Ver 31
import ItemVariantPackageList from './ItemVariantPackageList'; // Ver 33
import ItemVariantPackageForm from './ItemVariantPackageForm'; // Ver 33
import ItmVrntPkgSuplrsPriceList from './ItmVrntPkgSuplrsPriceList'; // Ver 34
import ItmVrntPkgSuplrsPriceForm from './ItmVrntPkgSuplrsPriceForm'; // Ver 34

// --- AUTHENTICATION CONTEXT ---
const AuthContext = createContext(null);

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loadingAuth, setLoadingAuth] = useState(true);

  // NEW: State for user's profile, including tenant association info
  const [userProfile, setUserProfile] = useState(null);
  const [loadingUserProfile, setLoadingUserProfile] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoadingAuth(false);
       // NEW: Fetch user profile when user logs in or state changes
      if (currentUser) {
        fetchCurrentUserProfile(currentUser);
      } else {
        setUserProfile(null); // Clear profile on logout
      }
     
    });
    return () => unsubscribe();
  }, []);

  // NEW code for ver 15
  const fetchCurrentUserProfile = async (currentUser) => {
    if (!currentUser) {
      setUserProfile(null);
      return;
    }
    setLoadingUserProfile(true);
    try {
      const token = await currentUser.getIdToken();
      const profileData = await userService.getUserProfile(currentUser.email, token);
      if (profileData && profileData.id) {
        setUserProfile(profileData);
      } else {
        setUserProfile(null); // No profile found
      }
    } catch (error) {
      if (error.message.includes('404')) {
        setUserProfile(null); // Profile not found is expected
      } else {
        console.error("Error fetching current user profile:", error);
      }
    } finally {
      setLoadingUserProfile(false);
    }
  };

  const login = async (email, password) => {
    try {
      // await signInWithEmailAndPassword(auth, email, password);
      // const userCredential = await signInWithEmailAndPassword(auth, email, password);
      await signInWithEmailAndPassword(auth, email, password); //never used ver 33
      // userCredential.user is handled by onAuthStateChanged
    } catch (error) {
      console.error("Firebase Login Error:", error.message);
      throw error;
    }
  };

  const signup = async (email, password) => { // NEW: Ver 20
    try {
      // NEW V22: Add 'return' here to pass the UserCredential back
      // await createUserWithEmailAndPassword(auth, email, password);
      return await createUserWithEmailAndPassword(auth, email, password);
    } catch (error) {
      console.error("Firebase Signup Error:", error.message);
      throw error;
    }
  };

  const verifyEmail = async (userToVerify) => { // NEW V23: Function to send email verification
    try {
      await sendEmailVerification(userToVerify);
      alert("Verification email sent! Please check your inbox (and spam folder).");
    } catch (error) {
      console.error("Firebase Email Verification Error:", error.message);
      throw error;
    }
  };



  const resetPassword = async (email) => { // NEW: Ver 20
    try {
      await sendPasswordResetEmail(auth, email);
      alert("Password reset email sent! Check your inbox.");
    } catch (error) {
      console.error("Firebase Reset Password Error:", error.message);
      throw error;
    }
  };

  const logout = async () => {
    console.log("Logging out.");
    try {
      await signOut(auth);
      setUserProfile(null); // Clear profile on logout - NEW: Ver 15
    } catch (error) {
      console.error("Firebase Logout Error:", error.message);
    }
  };

  const getIdToken = async () => {
    if (user) {
      return user.getIdToken();
    }
    return null;
  };

  // NEW: ver 15 - Function to force refresh user profile (e.g., after tenant creation)
  const refreshUserProfile = async () => {
    if (user) {
      await fetchCurrentUserProfile(user);
    }
  };

  // NEW: Ver 20 changed from above
  // const value = { user, login, signup, resetPassword, logout, loadingAuth, getIdToken, userProfile, loadingUserProfile, refreshUserProfile, setUserProfile }; // NEW V22: Expose setUserProfile

  const value = { user, login, signup, verifyEmail, resetPassword, logout, loadingAuth, getIdToken, userProfile, loadingUserProfile, refreshUserProfile, setUserProfile }; // NEW V23: Include verifyEmail

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

// const useAuth = () => {
export const useAuth = () => { // NEW: Export useAuth so UserProfileForm can import it
  return useContext(AuthContext);
};


// --- COMPONENTS ---

// 1. Login Screen
function LoginScreen() {
  const auth = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("user@example.com");
  const [password, setPassword] = useState("password");
  const [error, setError] = useState(null);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      await auth.login(email, password);
      navigate("/inventory");
    } catch (err) {
      setError(err.message || "An unexpected error occurred during login.");
      console.error("Failed to login:", err);
    }
  };

  const handleForgotPassword = async () => { // NEW: Ver 20
    if (!email) {
      alert("Please enter your email address to reset password.");
      return;
    }
    try {
      await auth.resetPassword(email);
    } catch (err) {
      setError(err.message || "Failed to send password reset email.");
      console.error("Forgot password error:", err);
    }
  };


  if (auth.user) {
    return <Navigate to="/inventory" replace />;
  }

  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleLogin}>
        {/* <h2>Inventory & Supplier Portal</h2> */}
        <h2>Food Tech App Ver 0.00 poc</h2>
        <h4>*** (Sandbox)) ***</h4>
        {error && <p style={{ color: 'red', marginBottom: '1rem' }}>{error}</p>}
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input 
            type="email" 
            id="email" 
            value={email} 
            onChange={(e) => setEmail(e.target.value)} 
            required 
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input 
            type="password" 
            id="password" 
            value={password} 
            onChange={(e) => setPassword(e.target.value)} 
            required 
          />
        </div>
        <button type="submit">Login</button>

{/* NEW Ver 20 */}
        <p className="forgot-password-link">
          Forgot password? <a href="#" onClick={handleForgotPassword}>Click HERE.</a>
        </p>
        <p className="link-text">
          First time user? <Link to="/signup">Sign up here.</Link>
        </p>

      </form>
    </div>
  );
}

// NEW: Ver 22 - AutoAddUserAndTenantProfiles Function
const AutoAddUserAndTenantProfiles = async (currentUser, setUserProfile) => { // NEW V22: Accept setUserProfile
  // Hardcoded values for the sample tenant
  const SAMPLE_SUBS_CO_DOC_ID = "BKvHRT3Dziqs5dFW4EuY"; // IMPORTANT: Ensure this tenant exists in your Firestore!
  const SAMPLE_ASSOC_SUBS_CO_FULL_NAME = "Sample Demo F&B Company";

  try {
    const token = await currentUser.getIdToken(); // Get ID token for the newly signed-up user

    const userProfilePayload = {
      AuthLoginName: currentUser.email,
      SubsCoDocId: SAMPLE_SUBS_CO_DOC_ID,
      AssocSubsCoFullName: SAMPLE_ASSOC_SUBS_CO_FULL_NAME,
      // You can add default FirstName, LastName if needed, or let user fill later
      FirstName: "<Please complete all fields>", // Ver 24
      LastName: "<if possible>",
      createdAt: new Date().toISOString(), // From previous update  Ver 24
      TenantProfileEditor: false, // NEW Ver 24: Default to false
    };

    // Attempt to add the user profile
    // await userService.addUserProfile(userProfilePayload, token);
    const addedProfile = await userService.addUserProfile(userProfilePayload, token); // Ver 24
    console.log("User profile automatically created successfully!");

    if (addedProfile && addedProfile.id) { // Ver 24
      setUserProfile(addedProfile);
    }

  } catch (error) {
    if (error.message.includes('409')) { // Conflict: Profile already exists (maybe user signed up before?)
      console.warn("User profile for new user already exists. Skipping auto-creation.");
    } else {
      console.error("Error in AutoAddUserAndTenantProfiles:", error);
      // Decide if you want to re-throw or just log. For now, logging is enough
      // as we don't want to block login if auto-add fails.
    }
  }
};


// NEW: Ver 20 - SignUpScreen Component
function SignUpScreen() {
  const auth = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState(null);

  const handleSignUp = async (e) => {
    e.preventDefault();
    setError(null);

    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    try {
      const userCredential = await auth.signup(email, password);

      // NEW: Automatically add user and tenant profiles AFTER successful signup
      if (userCredential && userCredential.user) {
        // NEW V23: Send email verification
        await auth.verifyEmail(userCredential.user);

        await AutoAddUserAndTenantProfiles(userCredential.user, auth.setUserProfile);
        // Refresh the user profile in AuthContext so it has the new tenant info
        await auth.refreshUserProfile();
      }

      // alert("Registration successful! You can now log in.");
      await auth.logout(); // New V22
      navigate("/login");
    } catch (err) {
      setError(err.message || "An unexpected error occurred during registration.");
      console.error("Sign up error:", err);
    }
  };

  return (
    <div className="signup-container">
      <form className="signup-form" onSubmit={handleSignUp}>
        <h2>Register New Account</h2>
        {error && <p style={{ color: 'red', marginBottom: '1rem' }}>{error}</p>}
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input 
            type="email" 
            id="email" 
            value={email} 
            onChange={(e) => setEmail(e.target.value)} 
            required 
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input 
            type="password" 
            id="password" 
            value={password} 
            onChange={(e) => setPassword(e.target.value)} 
            required 
          />
        </div>
        <div className="form-group">
          <label htmlFor="confirmPassword">Confirm Password</label>
          <input 
            type="password" 
            id="confirmPassword" 
            value={confirmPassword} 
            onChange={(e) => setConfirmPassword(e.target.value)} 
            required 
          />
        </div>
        <button type="submit">Sign Up</button>
        <p className="link-text">
          Already have an account? <Link to="/login">Login here.</Link>
        </p>
      </form>
    </div>
  );
}


// 2. Navigation Bar (UPDATED: Only hamburger and Logout button remain)
function Navbar({ onHamburgerClick }) { // NEW Ver 26 SB103: onHamburgerClick prop
  const auth = useAuth();
  return (
    <nav>
      <button className="hamburger-icon" onClick={onHamburgerClick}> {/* NEW: Hamburger icon */}
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
      </button>
      {/* NEW Ver 26 SB103: No navigation links here anymore, just the Logout button */}
      <button onClick={auth.logout} className="danger">Logout</button>
    </nav>
  );
}

// NEW Ver 26 SB103: Drawer Component
function Drawer({ isOpen, onClose, tenantIdFromProfile }) {
  const navigate = useNavigate(); // For navigating after selecting a link
  const handleLinkClick = (path) => {
    onClose(); // Close drawer when a link is clicked
    navigate(path); // Navigate to the path
  };

  return (
    <>
      <div className={`drawer ${isOpen ? 'open' : ''}`}>
        {/*<div className="drawer-header">App Modules</div>   Optional header for the drawer */}
        <ul className="drawer-links">
          <li><NavLink to={`/inventory`} onClick={() => handleLinkClick(`/inventory`)}>Inventory</NavLink></li>
          <li><NavLink to={`/suppliers`} onClick={() => handleLinkClick(`/suppliers`)}>Suppliers</NavLink></li>
          <li><NavLink to={`/employees`} onClick={() => handleLinkClick(`/employees`)}>Employees</NavLink></li>
          <li><NavLink to={`/raw-item-categories`} onClick={() => handleLinkClick(`/raw-item-categories`)}>Raw Item Categories</NavLink></li>
          <li><NavLink to={`/raw-items`} onClick={() => handleLinkClick(`/raw-items`)}>Raw Items</NavLink></li>
          <li><NavLink to={`/item-variants`} onClick={() => handleLinkClick(`/item-variants`)}>Item Variants</NavLink></li>
          <li><NavLink to={`/sites`} onClick={() => handleLinkClick(`/sites`)}>Sites</NavLink></li>
          <li><NavLink to={`/item-variant-packages`} onClick={() => handleLinkClick(`/item-variant-packages`)}>Variant Packages</NavLink></li>
          <li><NavLink to={`/itm-vrnt-pkg-suplrs-price`} onClick={() => handleLinkClick(`/itm-vrnt-pkg-suplrs-price`)}>Item Pkg Prices</NavLink></li> 
        </ul>
      </div>
      <div className={`drawer-overlay ${isOpen ? 'open' : ''}`} onClick={onClose}></div>
    </>
  );
}

// NEW: User Identifier Bar Component
function UserIdentifierBar() {
    const auth = useAuth();
    if (!auth.user || !auth.user.email) {
        return null; // Don't render if no user or email
    }

    // Check if userProfile is still loading or if it's available
    const tenantLinkContent = auth.loadingUserProfile
        ? "Loading company..."
        : auth.userProfile?.AssocSubsCoFullName || "<< None associated. Click to add one >>";

    return (
        <div className="user-identifier-bar">
            Company: <Link to="/tenant-profile"><span>{tenantLinkContent}</span></Link>
            <span style={{ marginLeft: '2rem' }}></span> {/* Spacer */}
            Logged in as: <Link to="/profile"><span>{auth.user.email}</span></Link>
        </div>
    );
}


// 3. Protected Route Wrapper & Layout
function ProtectedRoute({ children }) {
    const auth = useAuth();
    // const navigate = useNavigate(); // NEW V25 SB101: Need navigate here for redirect // navigate is never used
    useNavigate(); // NEW V25 SB101: Need navigate here for redirect  

    // if (auth.loadingAuth) {
    if (auth.loadingAuth || auth.loadingUserProfile) { // NEW: Wait for user profile to load too
         return <p>Loading application...</p>;
    }

    if (!auth.user) {
        return <Navigate to="/login" replace />;
    }

    // // NEW V23: Check if email is verified - from here // Deprecated by V25 SB101 below
    // if (!auth.user.emailVerified) {
    //     alert("Please verify your email address to access the application. Check your inbox for a verification link.<ALERT!! For test purposes this will proceed to enter the APP.>");
    //     auth.logout(); // Log out the unverified user
    //     return <Navigate to="/login" replace />;
    // } // NEW V23: Check if email is verified - to here

    // NEW V25 SB101: Check if email is verified. Redirect to verification screen if not.
    if (!auth.user.emailVerified) {
        // Instead of alert/logout/redirect to login, redirect to a dedicated screen
        return <Navigate to="/verify-email" replace />;
    }



    return children;
}


function AppLayout() {
    const auth = useAuth();
    const TENANT_ID_FROM_PROFILE = auth.userProfile?.SubsCoDocId || 'DEFAULT_TENANT_ID';

    const [isDrawerOpen, setIsDrawerOpen] = useState(false); // NEW: State for drawer

    const handleHamburgerClick = () => {
        setIsDrawerOpen(!isDrawerOpen);
    };

    const handleDrawerClose = () => {
        setIsDrawerOpen(false);
    };

    return (
        <>
            <Navbar onHamburgerClick={handleHamburgerClick} /> {/* Pass handler to Navbar */}
            <Drawer 
                isOpen={isDrawerOpen} 
                onClose={handleDrawerClose} 
                tenantIdFromProfile={TENANT_ID_FROM_PROFILE} // Pass tenantId to drawer
            />
            <UserIdentifierBar />
            <Outlet />
        </>
    )
}

// NEW: Generic Pagination Bar Component
function PaginationBar({
  currentPage,
  totalPages,
  itemsPerPage,
  totalItems,
  onPageChange,
  onLimitChange,
}) {
  const handlePageInputChange = (e) => {
    const newPage = parseInt(e.target.value, 10);
    if (!isNaN(newPage) && newPage >= 1 && newPage <= totalPages) {
      onPageChange(newPage);
    }
  };

  const handleLimitChange = (e) => {
    onLimitChange(parseInt(e.target.value, 10));
  };

  return (
    <div className="pagination-bar">
      <span>Page</span>
      <button onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1}>
        &lt;
      </button>
      <input
        type="number"
        min="1"
        max={totalPages}
        value={currentPage}
        onChange={handlePageInputChange}
        onBlur={handlePageInputChange} // Update on blur if user types then clicks away
      />
      <button onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages}>
        &gt;
      </button>
      <span>of {totalPages}</span>
      <span className="total-info">| Viewing</span>
      <select value={itemsPerPage} onChange={handleLimitChange}>
        <option value="10">10</option>
        <option value="20">20</option>
        <option value="50">50</option>
        <option value="100">100</option>
      </select>
      <span>records</span>
      <span className="total-info">| Found total {totalItems} records</span>
    </div>
  );
}


// --- SCREEN COMPONENTS (THE 4 MODULES) ---

// Module 1: Inventory List (UPDATED to pass tenantId from userProfile)
function InventoryList() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const auth = useAuth();

  // NEW: Pagination State -Ver 19
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(1);

  const TENANT_ID = auth.userProfile?.SubsCoDocId; // NEW: Get tenant ID dynamically
  const TENANT_FULL_NAME = auth.userProfile?.AssocSubsCoFullName;
  const tId = TENANT_ID;

  useEffect(() => {
    const fetchItems = async () => {

      if (!TENANT_ID) {
        setError("No associated company found. Please associate with one.");
        setLoading(false);
        return;
      }


      setLoading(true);
      setError(null);
      try {
        const token = await auth.getIdToken();
        if (!token) {
          setError("Authentication required. Please log in.");
          setLoading(false);
          return;
        }
        // const data = await inventoryService.getInventoryItems(token, tId);        
        // setItems(data); // Ver19

        console.log(`currentPage = ${currentPage}, itemsPerPage = ${itemsPerPage}`)

        const response = await inventoryService.getInventoryItems(token, tId, currentPage, itemsPerPage); // Ver 19
        setItems(response.items); // Ver19
        setTotalItems(response.totalItems); // Ver19
        setTotalPages(response.totalPages); // Ver19

      } catch (err) {
        console.error("Error fetching inventory from Cloud Function: ", err);
        setError(`Failed to load inventory: ${err.message}`);
      } finally {
        setLoading(false);
      }
    };
    fetchItems();
  }, [auth, TENANT_ID, tId, currentPage, itemsPerPage]); // Ver 19 changed to this

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleLimitChange = (newLimit) => {
    setItemsPerPage(newLimit);
    setCurrentPage(1); // Reset to first page when limit changes
  };


  if (loading) return <p>Loading inventory...</p>;
  if (error) return <p style={{ color: 'red' }}>Error: {error}</p>;
  // NEW ver 15: 
  if (!TENANT_ID) return <p className="container" style={{ color: 'orange' }}>Please <Link to="/tenant-profile">create a company profile</Link> to manage inventory.</p>;

  return (
    <div>
      <div className="page-header">
        <h2>Inventory List (Company: {TENANT_FULL_NAME || TENANT_ID})</h2>
        <Link to={`/inventory/add/${tId}`} className="btn secondary">Add New Item</Link>
        {/* <Link to={`/inventory/add`} className="btn secondary">Add New Item</Link> // ver 15 commented and uncommented above  */}
      </div>

      <PaginationBar
        currentPage={currentPage}
        totalPages={totalPages}
        itemsPerPage={itemsPerPage}
        totalItems={totalItems}
        onPageChange={handlePageChange}
        onLimitChange={handleLimitChange}
      />

      <table>
        <thead>
          {/* <tr><th>Name</th><th>Quantity</th><th>Price</th><th>Actions</th></tr> */}
          <tr><th>Name</th><th>Quantity</th><th>Price</th></tr> {/* Removed Actions column Ver19*/}
        </thead>
        <tbody>
          {items.map(item => (
            <tr key={item.id}>
              {/* <td>{item.id}</td> // Ver 15 remove from list */}
              {/* <td>{item.name}</td> // remove ver 19 */}
              <td><Link to={`/inventory/edit/${tId}/${item.id}`}>{item.name}</Link></td>
              <td>{item.quantity}</td>
              <td>${typeof item.price === 'number' ? item.price.toFixed(2) : '0.00'}</td>
              {/* <td><Link to={`/inventory/edit/${tId}/${item.id}`} className="btn">Edit</Link></td>  // remove ver 19 */}
              {/* <td><Link to={`/inventory/edit/:tId/${item.id}`} className="btn">Edit</Link></td>  // remove ver 19 */}
            </tr>
          ))}
        </tbody>
      </table>

      <PaginationBar
        currentPage={currentPage}
        totalPages={totalPages}
        itemsPerPage={itemsPerPage}
        totalItems={totalItems}
        onPageChange={handlePageChange}
        onLimitChange={handleLimitChange}
      />

    </div>
  );
}

// Module 2: Inventory Add/Edit Form (UNCHANGED)
function InventoryForm() {
  const { tId, id } = useParams();
  const navigate = useNavigate();
  const isEditing = Boolean(id);
  const auth = useAuth();
  
  const [formData, setFormData] = useState({ name: '', quantity: '', price: '' });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchItem = async () => {
      if (isEditing) {
        setLoading(true);
        setError(null);
        try {
          const token = await auth.getIdToken();
          if (!token) {
            setError("Authentication required. Please log in.");
            setLoading(false);
            return;
          }
          // const data = await callCloudFunction('getInventoryItemById', 'GET', null, id, token);
          console.log(`id = ${id}`)
          const data = await inventoryService.getInventoryItemById(id, token, tId);
          if (data) {
            setFormData(data);
          } else {
            setError("Item not found.");
            navigate('/inventory');
          }
        } catch (err) {
          console.error("Error fetching inventory item from Cloud Function: ", err);
          setError(`Failed to load item details: ${err.message}`);
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };
    fetchItem();
  // }, [id, isEditing, navigate, auth]); // Ver 15 Changed
  }, [id, isEditing, navigate, auth, tId]); // Ver 15 ... to this

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    try {
        const token = await auth.getIdToken();
        if (!token) {
            setError("Authentication required. Please log in.");
            return;
        }

        const payload = {
            ...formData,
            quantity: parseInt(formData.quantity, 10) || 0,
            price: parseFloat(formData.price) || 0.00
        };

        if (isEditing) {
            // await callCloudFunction('updateItem', 'PUT', payload, id, token);
            await inventoryService.updateInventoryItem(id, payload, token, tId);
        } else {
            // await callCloudFunction('addItem', 'POST', payload, null, token);
            await inventoryService.addInventoryItem(payload, token, tId);
        }
        navigate('/inventory');
    } catch (err) {
        console.error("Error saving inventory item via Cloud Function:", err);
        setError(`Failed to save item: ${err.message}`);
    }
  };

  if (loading) return <p>Loading item details...</p>;
  if (error) return <p style={{ color: 'red' }}>Error: {error}</p>;

  return (
    <div className="form-container">
      <h2>{isEditing ? 'Edit Item' : 'Add New Item'}</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Item Name</label>
          <input type="text" name="name" value={formData.name} onChange={handleChange} required />
        </div>
        <div className="form-group">
          <label>Quantity</label>
          <input type="number" name="quantity" value={formData.quantity} onChange={handleChange} required />
        </div>
        <div className="form-group">
          <label>Price</label>
          <input type="number" step="0.01" name="price" value={formData.price} onChange={handleChange} required />
        </div>
        <button type="submit">Save</button>
      </form>
    </div>
  );
}

// Module 3: Supplier List Wrapper (NEW)
function SupplierListWrapper() {
  const auth = useAuth();
  const TENANT_ID = auth.userProfile?.SubsCoDocId;

  return (
    <>
      {TENANT_ID ? (
        <main className="container">
          <SupplierList tenantId={TENANT_ID} />
        </main>
      ) : (
        <main className="container">
          <p style={{ color: 'orange' }}>Please <Link to="/tenant-profile">create a company profile</Link> to manage suppliers.</p>
        </main>
      )}
    </>
  );
}

// Module 4: Supplier Add/Edit Form Wrapper (NEW)
function SupplierFormWrapper() {
    const { tenantId, id } = useParams();
    return (
        <main className="container">
            <SupplierForm tenantId={tenantId} supplierId={id} />
        </main>
    );
}

// Module 5: Employee List (NEW Ver 21)
function EmployeeListWrapper() {
  const auth = useAuth();
  const TENANT_ID = auth.userProfile?.SubsCoDocId;
  const tId = TENANT_ID;
  console.log(`Apps.js TENANT_ID: ${TENANT_ID}, tId: ${tId}`);

  return (
    <>
      {TENANT_ID ? (
        <main className="container">
          <EmployeeList tenantId={TENANT_ID} /> {/* Pass tenantId as prop */}
        </main>
      ) : (
        <main className="container">
          <p style={{ color: 'orange' }}>Please <Link to="/tenant-profile">create a company profile</Link> to manage employees.</p>
        </main>
      )}
    </>
  );
}

// Module 6: Employee Add/Edit Form (NEW Ver 21)
function EmployeeFormWrapper() {
    // const { tenantId, id } = useParams(); // Get tenantId and employeeId from URL
    return (
        <main className="container">
            {/* <EmployeeForm tenantId={tenantId} employeeId={id} /> */}
            <EmployeeForm />
        </main>
    );
}

// Module 7: Raw Item Category List Wrapper (NEW)
function RawItemCategoryListWrapper() {
  const auth = useAuth();
  const TENANT_ID = auth.userProfile?.SubsCoDocId;

  return (
    <>
      {TENANT_ID ? (
        <main className="container">
          <RawItemCategoryList tenantId={TENANT_ID} />
        </main>
      ) : (
        <main className="container">
          <p style={{ color: 'orange' }}>Please <Link to="/tenant-profile">create a company profile</Link> to manage raw item categories.</p>
        </main>
      )}
    </>
  );
}

// Module 8: Raw Item Category Add/Edit Form Wrapper (NEW)
function RawItemCategoryFormWrapper() {
    const { tenantId, id } = useParams();
    return (
        <main className="container">
            <RawItemCategoryForm tenantId={tenantId} rawItemCategoryId={id} />
        </main>
    );
}

// Module 9: Raw Items List Wrapper (NEW ver 28)
function RawItemsListWrapper() {
  const auth = useAuth();
  const TENANT_ID = auth.userProfile?.SubsCoDocId;

  return (
    <>
      {TENANT_ID ? (
        <main className="container">
          <RawItemsList tenantId={TENANT_ID} />
        </main>
      ) : (
        <main className="container">
          <p style={{ color: 'orange' }}>Please <Link to="/tenant-profile">create a company profile</Link> to manage raw items.</p>
        </main>
      )}
    </>
  );
}

// Module 10: Raw Items Add/Edit Form Wrapper (NEW ver 28)
function RawItemsFormWrapper() {
    const { tenantId, id } = useParams();
    return (
        <main className="container">
            <RawItemsForm tenantId={tenantId} rawItemId={id} />
        </main>
    );
}

// Module 11: Item Variants List Wrapper (NEW)
function ItemVariantsListWrapper() {
  const auth = useAuth();
  const TENANT_ID = auth.userProfile?.SubsCoDocId;

  return (
    <>
      {TENANT_ID ? (
        <main className="container">
          <ItemVariantsList tenantId={TENANT_ID} />
        </main>
      ) : (
        <main className="container">
          <p style={{ color: 'orange' }}>Please <Link to="/tenant-profile">create a company profile</Link> to manage item variants.</p>
        </main>
      )}
    </>
  );
}

// Module 12: Item Variants Add/Edit Form Wrapper (NEW)
function ItemVariantsFormWrapper() {
    const { tenantId, id } = useParams();
    return (
        <main className="container">
            <ItemVariantsForm tenantId={tenantId} itemVariantId={id} />
        </main>
    );
}

// Module 13: Sites List Wrapper (NEW ver 31)
function SitesListWrapper() {
  const auth = useAuth();
  const TENANT_ID = auth.userProfile?.SubsCoDocId;

  return (
    <>
      {TENANT_ID ? (
        <main className="container">
          <SitesList tenantId={TENANT_ID} />
        </main>
      ) : (
        <main className="container">
          <p style={{ color: 'orange' }}>Please <Link to="/tenant-profile">create a company profile</Link> to manage sites.</p>
        </main>
      )}
    </>
  );
}

// Module 14: Sites Add/Edit/Details Form Wrapper (NEW ver 31)
function SitesFormWrapper() {
    const { tenantId, id, mode } = useParams(); // NEW ver 31: Get 'mode' from URL
    return (
        <main className="container">
            <SitesForm tenantId={tenantId} siteId={id} mode={mode} /> {/* Pass mode to form */}
        </main>
    );
}

// Module 15: Item Variant Package List Wrapper (NEW ver 33)
function ItemVariantPackageListWrapper() {
  const auth = useAuth();
  const TENANT_ID = auth.userProfile?.SubsCoDocId;

  return (
    <>
      {TENANT_ID ? (
        <main className="container">
          <ItemVariantPackageList tenantId={TENANT_ID} />
        </main>
      ) : (
        <main className="container">
          <p style={{ color: 'orange' }}>Please <Link to="/tenant-profile">create a company profile</Link> to manage item variant packages.</p>
        </main>
      )}
    </>
  );
}

// Module 16: Item Variant Package Add/Edit/Details Form Wrapper (NEW ver 33)
function ItemVariantPackageFormWrapper() {
    const { tenantId, id, mode } = useParams();
    console.log(`tenantId=${tenantId} id=${id} mode=${mode}`)
    return (
        <main className="container">
            <ItemVariantPackageForm tenantId={tenantId} itemVariantPackageId={id} mode={mode} />
        </main>
    );
}

// Module 17: Item Variant Package Supplier Price List Wrapper (NEW ver 34)
function ItmVrntPkgSuplrsPriceListWrapper() {
  const auth = useAuth();
  const TENANT_ID = auth.userProfile?.SubsCoDocId;

  return (
    <>
      {TENANT_ID ? (
        <main className="container">
          <ItmVrntPkgSuplrsPriceList tenantId={TENANT_ID} />
        </main>
      ) : (
        <main className="container">
          <p style={{ color: 'orange' }}>Please <Link to="/tenant-profile">create a company profile</Link> to manage item package supplier prices.</p>
        </main>
      )}
    </>
  );
}

// Module 18: Item Variant Package Supplier Price Add/Edit/Details Form Wrapper (NEW ver 34)
function ItmVrntPkgSuplrsPriceFormWrapper() {
    const { tenantId, id, mode } = useParams();
    return (
        <main className="container">
            <ItmVrntPkgSuplrsPriceForm tenantId={tenantId} itmVrntPkgSupPriceId={id} mode={mode} />
        </main>
    );
}

// --- MAIN APP COMPONENT ---
export default function App() {

  return (
    <AuthProvider>
      <HashRouter>
        <Routes>
          {/* NEW Ver 20: SignUp route */}
          <Route path="/signup" element={<SignUpScreen />} />
          <Route path="/login" element={<LoginScreen />} />
          {/* NEW Ver 25 SB101: Route for Email Verification Required Screen */}
          <Route path="/verify-email" element={<EmailVerificationScreen />} /> 
          <Route 
            element={
              <ProtectedRoute>
                <AppLayout />
              </ProtectedRoute>
            }
          >
            {/* Child routes render inside AppLayout's Outlet */}
            
            <Route path="/inventory" element={<main className="container"><InventoryList /></main>} />
            {/* <Route path="/inventory/add" element={<main className="container"><InventoryForm /></main>} /> */}
            <Route path="/inventory/add/:tId" element={<main className="container"><InventoryForm /></main>} />
            <Route path="/inventory/edit/:tId/:id" element={<main className="container"><InventoryForm /></main>} />
            
            <Route path="/suppliers" element={<main className="container"><SupplierListWrapper /></main>} />
            <Route path="/suppliers/add" element={<main className="container"><SupplierFormWrapper /></main>} />
            {/* <Route path="/suppliers/add:tId" element={<main className="container"><SupplierForm /></main>} /> */}
            {/* <Route path="/suppliers/edit/:tId/:id" element={<main className="container"><SupplierForm /></main>} /> */}
            <Route path="/suppliers/edit/:id" element={<main className="container"><SupplierFormWrapper /></main>} />

            <Route path="/profile" element={<main className="container"><UserProfileForm /></main>} />

            <Route path="/tenant-profile" element={<main className="container"><TenantProfileForm /></main>} />

            {/* NEW Ver 20: Employees routes */}
            {/* <Route path="/employees" element={<Navigate to={`/employees/tenant/${TENANT_ID}`} replace />} /> */}
            {/* <Route path="/employees" element={<Navigate to={`/employees/tenant/:tenantId`} replace />} /> */}
            {/* <Route path="/employees" element={<  EmployeeListWrapper   />} /> */}

            <Route path="/employees" element={<main className="container"><EmployeeListWrapper /></main>} />
            {/* <Route path="/employees" element={<main className="container"><EmployeeList /></main>} /> */}

            {/* <Route path="/employees/tenant/:tenantId" element={<EmployeeListWrapper />} /> */}

            {/* <Route path="/employees/add/:tenantId" element={<EmployeeFormWrapper />} /> */}
            {/* <Route path="/employees/add/:tenantId" element={<EmployeeForm />} />
            <Route path="/employees/edit/:tenantId/:id" element={<EmployeeFormWrapper />} /> */}

            <Route path="/employees/add" element={<EmployeeForm />} />
            <Route path="/employees/edit/:id" element={<EmployeeFormWrapper />} />


            {/* NEW ver 27: Raw Item Categories routes */}
            <Route path="/raw-item-categories" element={<main className="container"><RawItemCategoryListWrapper /></main>} />
            <Route path="/raw-item-categories/add" element={<RawItemCategoryFormWrapper />} />
            <Route path="/raw-item-categories/edit/:id" element={<RawItemCategoryFormWrapper />} />

            {/* NEW ver 28: Raw Items routes */}
            <Route path="/raw-items" element={<main className="container"><RawItemsListWrapper /></main>} />
            <Route path="/raw-items/add" element={<RawItemsFormWrapper />} />
            <Route path="/raw-items/edit/:id" element={<RawItemsFormWrapper />} />

            {/* NEW ver 29: Item Variants routes */}
            <Route path="/item-variants" element={<ItemVariantsListWrapper />} />
            <Route path="/item-variants/add" element={<ItemVariantsFormWrapper />} />
            <Route path="/item-variants/edit/:id" element={<ItemVariantsFormWrapper />} />

            {/* NEW ver 31: Sites routes */}
            <Route path="/sites" element={<SitesListWrapper />} />
            <Route path="/sites/add" element={<SitesFormWrapper />} />
            <Route path="/sites/edit/:id" element={<SitesFormWrapper />} />
            <Route path="/sites/details/:id" element={<SitesFormWrapper />} /> {/* NEW ver 31: Details mode route */}

            {/* NEW ver 33: Item Variant Packages routes routes */}
            <Route path="/item-variant-packages" element={<ItemVariantPackageListWrapper />} />
            <Route path="/item-variant-packages/add" element={<ItemVariantPackageFormWrapper mode="add" />} />
            <Route path="/item-variant-packages/edit/:id" element={<ItemVariantPackageFormWrapper mode="edit" />} />
            <Route path="/item-variant-packages/details/:id" element={<ItemVariantPackageFormWrapper mode="details" />} />
          
            {/* NEW ver 34: Item Variant Package Supplier Price routes */}
            {/* <Route path="/itm-vrnt-pkg-suplrs-price" element={<Navigate to={`/itm-vrnt-pkg-suplrs-price`} replace />} /> */}
            <Route path="/itm-vrnt-pkg-suplrs-price" element={<ItmVrntPkgSuplrsPriceListWrapper />} />
            <Route path="/itm-vrnt-pkg-suplrs-price/add" element={<ItmVrntPkgSuplrsPriceFormWrapper mode="add" />} />
            <Route path="/itm-vrnt-pkg-suplrs-price/edit/:id" element={<ItmVrntPkgSuplrsPriceFormWrapper mode="edit" />} />
            <Route path="/itm-vrnt-pkg-suplrs-price/details/:id" element={<ItmVrntPkgSuplrsPriceFormWrapper mode="details" />} />

            {/* NEW ver 32 replaced by below
            <Route path="/" element={<Navigate to="/inventory/:tId" replace />} />
            <Route path="*" element={<Navigate to="/inventory/:tId" replace />} />
            <Route path="/inventory" element={<Navigate to="/inventory/:tId" replace />} /> */}

            <Route path="/" element={<Navigate to="/inventory" replace />} />
            <Route path="*" element={<Navigate to="/inventory" replace />} />
            {/* <Route path="/inventory" element={<Navigate to="/inventory/:tId" replace />} /> */}


          </Route>
        </Routes>
      </HashRouter>
    </AuthProvider>
  );
}